import { QuestionData } from "./stub-response";

export const getQuestionAPIresponse = async () => {
  try {
    let response = await new Promise((resolve) => {
      setTimeout(() => {
        let _data = QuestionData;
        resolve(_data);
      }, 1000);
    });
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const fetchTagsAPIresponse = async (query: string) => {
  try {
    return new Promise((resolve) => {
      setTimeout(() => {
        const tags = [
          "React",
          "JavaScript",
          "TypeScript",
          "AI",
          "Machine Learning",
        ];

        resolve(tags);
      }, 1000);
    });
  } catch (error) {
    return Promise.reject(error);
  }
};
